export enum SendMailStepEnum {
    None = 0,
    Request = 1,
    Responce = 2
}